import { IBarcodeObject } from "../../../../../domain/editableFormat/objects";
import { IBarcodeObjectBean } from "../../beans/objects";
import { BarcodeStyleTranslator, BarcodeItemsTranslator } from "./properties";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { TextPresentableObjectTranslator } from "./base";

export class BarcodeObjectTranslator extends AbstractObjectTranslator<IBarcodeObject, IBarcodeObjectBean> {
  constructor() {
    super(new TextPresentableObjectTranslator());
  }

  protected shouldRecordName(source: IBarcodeObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IBarcodeObject, bean: IBarcodeObjectBean, formatId: number): void {
    source.barcodeStyle = this.barcodeStyle.from(bean);
    source.items = this.items.from(bean);
  }

  overwriteBean(source: IBarcodeObjectBean, object: IBarcodeObject): void {
    source["@edit"] = "2";
    source["@quote"] = "0";
    const style = this.barcodeStyle.to(object);
    source["@type"] = style.type;
    source["@separate"] = style.separate;
    source["@size"] = style.size;
    source["@level"] = style.level;
    source["@mode"] = style.mode;
    source.barcodeitem = this.items.to(object);
  }

  private readonly barcodeStyle = new BarcodeStyleTranslator();
  private readonly items = new BarcodeItemsTranslator();
}
